module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/home/circleci/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/home/circleci/node_modules/eslint-loader/dist/cjs.js??ruleSet[1].rules[1].use[0]!/home/circleci/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}